import type { FeeRecipientRole } from '../models/settlementTypes';

/** Display label for a fee-recipient role — shared by Step 2 (co-counsel expenses)
 *  and Step 3 (fee split by recipient), both of which render the same role badges. */
export const ROLE_LABELS: Record<FeeRecipientRole, string> = {
  coCounsel: 'Co-counsel',
  referringAttorney: 'Referring attorney',
  other: 'Other',
};

export function roleLabel(role: FeeRecipientRole): string {
  return ROLE_LABELS[role] ?? role;
}
